import { BaseRepository } from "@/repositories/base-repository"
import { type IKnownBusinessEntityContact } from "@/interfaces/api/known-business-entity-contact.interface.ts"

export class KnownBusinessEntityContactRepository extends BaseRepository<IKnownBusinessEntityContact> {
  protected resourcePath = "core/known-business-entities-contacts"
}
